import stat from './index';

export default(baseClass, status, disabled = false, additionalMods = {}, alwaysIncludeMods = false) => {
    let s = baseClass;
    if(disabled) {
        s += ` ${baseClass}--disabled`;
    }
    if(!disabled || alwaysIncludeMods){
        if(status !== stat.STANDBY ){
            s += ` ${baseClass}--${status}`;
        }
        if(status !== stat.LOADING){
            Object.keys(additionalMods).map(key => {
                if(additionalMods[key]) {
                    s+= ` ${baseClass}--${key}`;
                }
            });
        }
    }

    return s;
};
